import React from 'react';
import { Column } from 'Shared/components';
import { useAppContext } from 'QuoteApp/services/providers';
import { NoResults } from '../../NoResults';
import { ReportDetailHeaderRow } from '../../ReportDetailHeaderRow';
import { LendingLossRow } from './LendingLossRow';

import { AccidentDataType } from 'QuoteApp/services/endpoints/GetDetails';
import { useQuoteAppFeatureFlags } from 'QuoteApp/utils/hooks';
import styles from './styles.module.css';
import { useEdit } from 'QuoteApp/utils/contexts';

export const LendingLossReport = () => {
  const { details } = useAppContext();
  const {
    assumeAtFaultFlag,
    collectTypeOfLossFlag,
  } = useQuoteAppFeatureFlags();

  const { editingId } = useEdit();

  const lendingLossIdForDriverId: {
    driverId: string;
    accidentId: string;
  }[] = [];

  const lendingLosses: Record<string, AccidentDataType> = Object.keys(
    details.drivers
  )
    .filter(
      driverId => details.drivers[driverId].driverType !== 'excludedPerson'
    )
    .reduce((obj, driverId) => {
      const filteredAccidents = Object.fromEntries(
        Object.entries(details.drivers[driverId].accidents).filter(
          ([id, accident]) => {
            const shouldShow =
              accident.isLendingLoss &&
              accident.claimStatus.value !== 'Collapsed';

            if (shouldShow)
              lendingLossIdForDriverId.push({ driverId, accidentId: id });

            return shouldShow;
          }
        )
      );

      return { ...obj, ...filteredAccidents };
    }, {});

  const canChallenge = lendingLossIdForDriverId
    .map(({ driverId }) => driverId)
    .filter((x, i, a) => a.indexOf(x) === i)
    .some(driverId => {
      return Object.keys(lendingLosses).some(lendingLossId => {
        const lendingLoss =
          details.commands.drivers[driverId].accidents[lendingLossId];
        return (
          lendingLoss &&
          lendingLoss.some(({ name }) => name === 'challenge_accident')
        );
      });
    });

  return (
    <div data-testid="lending-loss-report-details">
      <ReportDetailHeaderRow
        canChallenge={canChallenge}
        includeRemove={!editingId}
        claim
      >
        <Column variant="quarter" className={styles.datePickerWrapper}>
          Accident Date
        </Column>
        <Column variant="quarter">Operator</Column>
        {collectTypeOfLossFlag && (
          <>
            <Column variant="sixth">Claim Type</Column>
            <Column variant="sixth" className={styles.lossAmountWrapper}>
              Loss Amount
            </Column>
          </>
        )}
        {!assumeAtFaultFlag && <Column variant="quarter">Fault</Column>}
      </ReportDetailHeaderRow>
      {Object.keys(lendingLosses).length ? (
        <ul>
          {Object.values(lendingLosses).map(lendingLoss => (
            <LendingLossRow
              key={lendingLoss.identifier}
              lendingLoss={lendingLoss}
              canChallenge={canChallenge}
              lendingLossIdForDriverId={lendingLossIdForDriverId}
            />
          ))}
        </ul>
      ) : null}
      <NoResults isVisible={!Object.keys(lendingLosses).length}>
        No lending loss discovered
      </NoResults>
    </div>
  );
};
